<script>
    import { section } from "../store/section.js";
    import { active_subscription } from "../store/subscription.js";
    import { active_workspace } from "../store/workspace.js";
    import { token } from "../store/token.js";
    import HeadingContent from "./component/HeadingContent.svelte";

    const set_section = (selected_section) => {
        section.set(selected_section);
    };

    const openChargebeePortal = async (type) => {
        console.log("clicksed", $active_subscription);
        if (window.Chargebee == undefined) {
            return setTimeout(() => {
                openChargebeePortal();
            }, 500);
        }

        var cb_instance = window.Chargebee.init({
            site: `${process.env.CHARGEBEE_SITE}`,
        });

        var billing_portal_workspace_url = new URL(
            `${process.env.API_ROOT}/billing/portal/workspace/session`,
        );

        const billing_portal_workspace_response = await fetch(
            billing_portal_workspace_url,
            {
                method: "post",
                headers: {
                    Authorization: "Bearer " + $token,
                    "control-workspace": $active_workspace.string_id,
                },
            },
        );

        var billing_portal_workspace_json =
            await billing_portal_workspace_response.json();

        cb_instance.setPortalSession(function () {
            return new Promise(function (resolve, reject) {
                resolve(billing_portal_workspace_json);
            });
        });

        var cb_portal = cb_instance.createChargebeePortal();

        if (type == "address") {
            cb_portal.openSection({
                sectionType: Chargebee.getPortalSections().ADDRESS,
            });
        } else if (type == "card") {
            cb_portal.openSection({
                sectionType: Chargebee.getPortalSections().PAYMENT_SOURCES,
            });
        } else if (type == "subscription") {
            cb_portal.openSection({
                sectionType: Chargebee.getPortalSections().SUBSCRIPTION_DETAILS,
                params: {
                    subscriptionId: $active_subscription.subscription_id,
                }
            });
        }
    };
</script>

<svelte:head>
    <script src="https://js.chargebee.com/v2/chargebee.js"></script>
</svelte:head>

<div class="settings-holder settings-active">
    <!-- Settings Billing Payment Methods (Second Level)-->
    <div class="settings-holder-content content-active">
        <HeadingContent
            title="Payment methods"
            back_button_enabled={true}
            back_button_click_action={() => {
                set_section("account/workspaces/overview/billing");
            }}
        />
        <!--
        <div class="settings-heading">
            <div
                class="heading-block"
                on:click={() => {
                    set_section("account/workspaces/overview/billing");
                }}
            >
                <a class="nav-opener" href="#"
                    ><i class="icon icon-navigation" /></a
                ><a class="nav-back" href="#">
                    <div class="ico-holder">
                        <i class="icon icon-chevron-left" />
                    </div>
                    <div class="title-holder">
                        <strong class="settings-title">Payment methods</strong>
                    </div></a
                >
            </div>
        </div>
        -->
        <div class="settings-content">
            <div class="settings-content-holder">
                <div class="card-h-100">
                    <div
                        class="card-settings-main card-join-bottom card bg-transparent-mobile"
                    >
                        <div class="card-body">
                            <nav>
                                <ul class="nav-second-level nav-settings">
                                    <li>
                                        <div class="opener-third-level">
                                            <div class="df-row df-aic gx-2">
                                                <div class="col">
                                                    <div class="opener-text">
                                                        <div
                                                            class="df-row df-jcb df-aic"
                                                        >
                                                            <div class="col">
                                                                <strong
                                                                    class="nav-title"
                                                                    >Card
                                                                    information</strong
                                                                >
                                                                <div
                                                                    class="nav-text"
                                                                >
                                                                    <p>
                                                                        {$active_subscription
                                                                            .raw
                                                                            .card
                                                                            .card_type}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="opener-third-level">
                                            <div class="df-row df-aic gx-2">
                                                <div class="col">
                                                    <div class="opener-text">
                                                        <div
                                                            class="df-row df-jcb df-aic"
                                                        >
                                                            <div class="col">
                                                                <strong
                                                                    class="nav-title"
                                                                    >Invoice
                                                                    Settings</strong
                                                                >
                                                                <div
                                                                    class="nav-text"
                                                                >
                                                                    <p>
                                                                        Update
                                                                        your
                                                                        company
                                                                        info
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
                <div
                    class="card-settings-main-footer card bg-transparent-mobile"
                >
                    <div class="card-body">
                        <div class="df-row df-aic df-md-jce gx-1">
                            <div class="col-md-auto">
                                <a
                                    class="btn btn-dark"
                                    href="#b"
                                    on:click={() => {
                                        openChargebeePortal("address");
                                    }}>Edit Invoice Information</a
                                >
                            </div>
                            <div class="col-md-auto">
                                <a
                                    class="btn btn-primary"
                                    href="#a"
                                    on:click={() => {
                                        openChargebeePortal("card");
                                    }}>Update Card</a
                                >
                            </div>
                            <div class="col-md-auto">
                                <a
                                    class="btn btn-danger"
                                    href="#a"
                                    on:click={() => {
                                        openChargebeePortal("subscription");
                                    }}>Cancel Plan</a
                                >
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
